'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module3App6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    profile: state.profile.data,
    app: state.moduleData.data.module3.app6
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3App6, _Component);

  function Module3App6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3App6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3App6.__proto__ || (0, _getPrototypeOf2.default)(Module3App6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 6,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'Mealtime Strategies - Meal Preparation'
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3App6, [{
    key: 'getHeShe',


    /*
     * Returns he/she depending on child gender
     */
    value: function getHeShe() {
      if (this.props.profile.childGender === 'Male') {
        return 'he';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'she';
      }

      return 'he/she';
    }

    /*
     * Returns him/her depending on child gender
     */

  }, {
    key: 'getHimHer',
    value: function getHimHer() {
      if (this.props.profile.childGender === 'Male') {
        return 'him';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'her';
      }

      return 'them';
    }

    /*
     * Handle when user finishes this module
     */

  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var img6 = require('../Assets/img6.jpeg');
      var img7 = require('../Assets/img7.jpeg');
      var img8 = require('../Assets/img8.jpeg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 3'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 7: Food preparation'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8, sm: 8, xs: 8 },
              _react2.default.createElement(
                'h4',
                null,
                'Make it appealing'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Preparing vegetables or meals in an appealing, exciting, or fun way is a good strategy to get children interested. We have a few ideas in recipes like the \'pizza people\' recipe.'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Mix it in'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Preparing meals with vegies mixed-in is a great way of getting kids to eat their vegies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Remember, you can find a few recipe ideas on the \'fruit and vegie based meals and snacks\' guide in the recipes tab.',
                _react2.default.createElement('br', null),
                'When you do this, it\'s good if you can also provide a sample of the vegetables on their own so that ',
                this.props.profile.childName,
                ' becomes familiar with them. By doing this, it\'s likely to lead to acceptance of that vegetable so that in time you won\'t have to disguise it.'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Use sauces'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If it is a vegetable you know they don\'t like, often kids will eat vegies if they are served with a sauce or accompaniment that they like, such as cheese, sweet chilli sauces, or honey. Eg. You could drizzle honey over carrots, pumpkin and/or sweet potato. It\'s better if you can use healthier sauces that are low in sugar, fat and salt. Also be mindful of offering vegetables raw or cooked without sauce, so that children come to accept the taste and texture of vegetables without additional flavours.'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Try cooked and uncooked'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Sometimes kids will eat a fruit or vegetable cooked and won\'t eat it when it\'s uncooked and vice versa. Some even like their peas still frozen. Try poached pears or banna in orange juice.'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Timing'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Let your children snack on their vegies while waiting for dinner to be ready. This is when they are the most hungry and likely to eat up.'
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 8: Variety'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Serving meals and vegetables ',
                    this.getHeShe(),
                    ' likes helps provide routine and can be an effective way of getting kids to eat vegies'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'However, giving and ',
                    _react2.default.createElement(
                      'strong',
                      { className: styles.orangeText },
                      'exposing ',
                      this.getHimHer(),
                      ' to a variety of different fruits and vegetables'
                    ),
                    ' is important too'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Trying a new meal now and then, will expose ',
                    this.getHimHer(),
                    ' to different foods, and as ',
                    this.getHeShe(),
                    ' becomes more familiar with them, he/she will be more likely to eat them'
                  )
                )
              ),
              _react2.default.createElement(
                'h3',
                null,
                'Strategy 9: Involving children in decision making'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Involving your child in decisions about food is another useful strategy'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Kids are more likely to eat when they have made some decisions about the meal, and feel a ',
                    _react2.default.createElement(
                      'strong',
                      { className: styles.orangeText },
                      'sense of ownership'
                    )
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'However, it\'s best to limit their choices. For example, give your child a choice between two different vegies. Ask if he/she would prefer beans or broccoli'
                  )
                )
              ),
              _react2.default.createElement('div', { className: styles.spacer20 }),
              _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
              _react2.default.createElement('div', { className: styles.spacer40 })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 4, sm: 4, xs: 4 },
              _react2.default.createElement(ReactBootstrap.Image, { src: img6, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer40 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: img7, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer40 }),
              _react2.default.createElement(ReactBootstrap.Image, { src: img8, responsive: true }),
              _react2.default.createElement('div', { className: styles.spacer40 })
            ),
            _react2.default.createElement('div', { className: styles.spacer100 })
          )
        )
      );
    }
  }]);
  return Module3App6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3App6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/App/App6.js
// module id = 1201
// module chunks = 0